import { NgModule } from '@angular/core';
import { SpeedOfReplyListComponent } from './speed-of-reply-list.component';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '../../../_guards/auth.guard';
import { RoleGuard } from '../../../_guards/role.guard';
import { FuseWidgetModule } from '../../../core/components/widget/widget.module';
import { NgxChartsModule } from '@swimlane/ngx-charts';

const routes = [
  {
      path     : 'reply-list',
      component: SpeedOfReplyListComponent,
      canActivate: [AuthGuard,RoleGuard]
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    FuseWidgetModule,
    NgxChartsModule
  ],
  declarations: [
    SpeedOfReplyListComponent
  ],
  providers: [
    AuthGuard,
    RoleGuard
  ]
})

export class SpeedOfReplyListModule { }